import React from 'react';
import CventBlocks, { Block, BlocksProps } from '@cvent/blocks/components/Blocks';
import { ThemeColors } from '@cvent/blocks/utils/types';
import { useThemeValues } from '@context/ThemeProvider';

export { Block };

export type Props = Omit<BlocksProps, keyof ThemeColors>;

export default function Blocks({ children, ...props }: Props): JSX.Element {
  const { primary, secondary, background, mood, safeMode, preferFormula, headingFont, bodyFont } = useThemeValues();
  return (
    <CventBlocks
      {...props}
      primary={primary}
      secondary={secondary}
      background={background}
      mood={mood}
      safeMode={safeMode}
      preferFormula={preferFormula}
      headingFont={headingFont}
      bodyFont={bodyFont}
    >
      {children}
    </CventBlocks>
  );
}
